import AhoyEvent from 'shared/ahoy_event';

export default class ContentAccessWatcher {
    static get interval() {
        return (Number(window.contentAccessWatcherInterval) || 300) * 1000;
    }

    static watch(id, type) {
        this.watchInterval = setInterval(function () {this.check(id, type);}.bind(this), this.interval);
    }

    static check(id, type) {
        var url = '/interactions_content_access.json?video_id='+id+'&type='+type;
        $.ajax({
            method: 'GET',
            dataType: 'json',
            url: url
        }).done(function(data){
            this.onInteractionContentAccessSuccess(id, type, data);
        }.bind(this)).fail(function(){
            this.onInteractionContentAccessFail(id, type);
        }.bind(this));
    }

    static onInteractionContentAccessSuccess(id, type, data) {
        if (data.allowed == false) {
            this.killPlayer();
            this.showBanner();
            this.stopWatching();
            this.sendKillEvent(id, type);
        }

        if (data.stop_polling) {
            this.stopWatching();
        }
    }

    static onInteractionContentAccessFail(id, type) {
        this.stopWatching();
        this.sendErrorEvent(id, type);
    }

    static killPlayer() {
        try {
            window.player.dispose();
        } catch (e) { window.console.log("Error when disposing player."); }
    }

    static showBanner() {
        var premiumBanner = document.querySelector('.js-watchpage-premium-banner');
        if (premiumBanner) {
            premiumBanner.classList.remove('hide');
            premiumBanner.style.zIndex = 1;
        }
    }

    static stopWatching() {
        clearInterval(this.watchInterval);
    }

    static sendKillEvent(id, type) {
        AhoyEvent.send('VIDIO::CONTENT_ACCESS_WATCHER', {
            'action': 'kill',
            'id'    : id,
            'type'  : type
        });
    }

    static sendErrorEvent(id, type) {
        AhoyEvent.send('VIDIO::CONTENT_ACCESS_WATCHER', {
            'action': 'error',
            'id'    : id,
            'type'  : type
        });
    }
}
